<div class="">
  <div class="snack-bar-info snack-bar-inline p-3" [ngClass]="data.class">
    <span class="w-100">{{ data.title | translate }}</span>
    <span>{{ data.message | translate}}</span>
  </div>
</div>
